<template>
  <div class="metafield-edit-html">
    <BaseJson
      :name="$attrs.name"
      :value="value"
      :label="field.label"
      :hint="hint"
      @input="onInput"
      ></BaseJson>
  </div>
</template>

<script>
import { forSingleMetafield } from '@/mixins/metafields-changed-detection.mixin'

export default {
  mixins: [ forSingleMetafield(true) ],
  props: {
    field: Object,
    value: String,
    hint: String,
    subFormData: Object
  },
  methods: {
    onInput (val) {
      this.$emit('input', val === '' ? null : val)
    }
  },
}
</script>

<style lang="scss">
  .metafield-edit-html {

  }
</style>



// WEBPACK FOOTER //
// src/components/metafields-edit/metafields/MetafieldEditJson.vue